/**
 * @deprecated Use the `SiloLogoIcon` instead.
 */
export const SiloLogo = ({ className }: { className?: string }) => (
  <svg
    className={`h-7 md:h-[37px] w-auto ${className}`}
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1240 530"
  >
    <path
      fill="white"
      d="M279.41,221.76V20H164.12a144.12,144.12,0,0,0,0,288.24h28.82V221.76Z"
    />
    <path
      fill="white"
      d="M308.24,221.76H279.41v86.48H192.94V510h115.3a144.12,144.12,0,0,0,0-288.24Z"
    />
    <path
      fill="white"
      d="M620.3,389.72q-22.72-9.93-35.7-28.19t-13-42.6h49.49q1.62,18.26,14.4,30t35.9,11.77q23.94,0,37.32-11.56t13.39-29.82q0-14.19-8.32-23.12a55.66,55.66,0,0,0-20.69-13.8q-12.37-4.86-34.27-10.54-27.6-7.31-44.83-14.81a74,74,0,0,1-29.41-23.32q-12.17-15.83-12.17-42.19,0-24.34,12.17-42.59t34.08-28q21.9-9.74,50.7-9.74,41,0,67.14,20.49t29,56.18H714.41q-1.21-15.4-14.6-26.37t-35.29-10.95q-19.89,0-32.46,10.14t-12.57,29.21q0,13,7.91,21.29a55.85,55.85,0,0,0,20.08,13.19A311.62,311.62,0,0,0,680.74,235q28,7.72,45.64,15.42a76.11,76.11,0,0,1,30,23.73q12.36,16,12.37,42.8a77,77,0,0,1-11.56,40.56q-11.57,19.06-33.67,30.63t-52.13,11.56Q643,399.66,620.3,389.72Z"
    />
    <path
      fill="white"
      d="M813.79,135.17a28.61,28.61,0,0,1-8.52-21.09,29.1,29.1,0,0,1,29.61-29.61A28.16,28.16,0,0,1,855.57,93a28.64,28.64,0,0,1,8.52,21.09,28.61,28.61,0,0,1-8.52,21.09,28.16,28.16,0,0,1-20.69,8.52A28.64,28.64,0,0,1,813.79,135.17Zm43.81,38.14V396.82H811.36V173.31Z"
    />
    <path fill="white" d="M954.34,96.64V396.82H908.1V96.64Z" />
    <path
      fill="white"
      d="M1046.79,386.07a103.42,103.42,0,0,1-40.16-40.57Q992,319.34,992,284.86q0-34.08,15-60.44a103.65,103.65,0,0,1,41-40.57q26-14.19,58-14.19t58,14.19a103.71,103.71,0,0,1,41,40.57q15,26.37,15,60.44t-15.42,60.44a106.69,106.69,0,0,1-42,40.77q-26.56,14.4-58.61,14.4Q1072.34,400.47,1046.79,386.07Zm90.66-34.28q15.61-8.52,25.35-25.56t9.74-41.37q0-24.35-9.33-41.17t-24.74-25.36a67.72,67.72,0,0,0-33.27-8.52,66.52,66.52,0,0,0-33.06,8.52q-15.21,8.52-24.13,25.36t-8.93,41.17q0,36.11,18.46,55.77T1104,360.31A68.8,68.8,0,0,0,1137.45,351.79Z"
    />
  </svg>
);
